/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OtherBoards/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BoardsWelcome from 'DesignSystem/Svgs/BoardsWelcome/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function OtherBoards({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Boards/Content/No/OtherBoards",
  innerRef,
  isActive
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtColorsBrandGreen = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.green'
        })
let dtColorsBrandGreen10 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.green_10'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="OtherBoards.Horizontal"
  data-view-path={viewPath}
 style={{'--mr-1-ZBDpv7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--ml-2-ZBDpv7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-3-ZBDpv7': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal}`}
/>
<div
  data-testid="OtherBoards.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--ml-2-ZBDpv7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-1-ZBDpv7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-5-ZBDpv7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-6-ZBDpv7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-9-ZBDpv7': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--btrr-10-ZBDpv7': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bblr-11-ZBDpv7': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bbrr-12-ZBDpv7': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--mb-14-ZBDpv7': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--bw-4-ZBDpv7': isActive ? "1px" : "1px",'--bs-7-ZBDpv7': isActive ? "dashed" : "dashed",'--bc-8-ZBDpv7': isActive ? dtColorsBrandGreen : dtColorsNeutral400,'--bc-13-ZBDpv7': isActive ? dtColorsBrandGreen10 : "transparent"}}
 className={`views-block ${styles.Vertical}`}
>
<BoardsWelcome
  viewPath={`${viewPath}/BoardsWelcome`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="normal"
 marginTop={dtSpaceM}
 text="Other Boards"
/>
</div>
{children}
</React.Fragment>)
}